module.exports = __webpack_public_path__ + "f2e5dea9f7134ca9642c8a9173215d98.png";